import React from 'react';
import { Tracking } from 'web-core/src/tracking';
import { VISON_REDIRECT } from 'client/constants/amplitudeTracker';
import LinkButton from 'client/components/button/linkButton';
import FunnelStep from 'client/components/funnelStep';
import Translate from 'client/components/translate';

const LocationUnsupportedPage = () => (
  <FunnelStep index={0} pathName="location" descriptKey="vision.nav.location">
    <div className="center-col pad-top-3 text-center pad-x">
      <div className="header">
        <h3>
          <Translate path="vision.unsupported.header" />
        </h3>
        <div className="pad-top-2">
          <Translate path="vision.unsupported.subheader" />
        </div>
        <div className="pad-top-2 bold">
          <LinkButton
            className="cta-button"
            href="https://myplan.ameritas.com/stride"
            onClick={() => {
              Tracking.track(VISON_REDIRECT);
            }}
          >
            <Translate path="vision.unsupported.cta" />
          </LinkButton>
        </div>
      </div>
    </div>
  </FunnelStep>
);

export default LocationUnsupportedPage;
